import React, { useState, useEffect } from "react";
import DataTable from "../../../components/DataTable";
import { apiJson } from "../../../utils/api";

const Degrees = () => {
  const [degreeTypes, setDegreeTypes] = useState([]);
  const [subjects, setSubjects] = useState([]);

  useEffect(() => {
    apiJson("/api/admin/master/degree-types").then(setDegreeTypes).catch(() => {});
    apiJson("/api/admin/master/subjects").then(setSubjects).catch(() => {});
  }, []);

  return (
    <DataTable
      title="Degrees"
      apiPath="/api/admin/master/degrees"
      columns={[
        { key: "id", label: "ID" },
        { key: "name", label: "Name" },
        { label: "Type", render: (item) => item.degreeType?.name || "-" },
        { label: "Major Subject", render: (item) => item.majorSubject?.name || "-" },
        { key: "durationYears", label: "Years" },
        { key: "totalSemesters", label: "Semesters" },
        { key: "isActive", label: "Active" },
      ]}
      formFields={[
        { key: "name", label: "Degree Name", required: true },
        {
          key: "degreeTypeId",
          label: "Degree Type",
          type: "select",
          required: true,
          options: degreeTypes.map((d) => ({ value: d.id, label: d.name })),
        },
        {
          key: "majorSubjectId",
          label: "Major Subject",
          type: "select",
          options: [{ value: "", label: "None" }, ...subjects.map((s) => ({ value: s.id, label: s.name }))],
        },
        { key: "durationYears", label: "Duration (Years)", type: "number", required: true },
        { key: "totalSemesters", label: "Total Semesters", type: "number", required: true },
        { key: "isActive", label: "Active", type: "checkbox", defaultValue: true },
      ]}
    />
  );
};

export default Degrees;
